import React, { Component, Fragment, useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Badge, Collapse } from '@mui/material';
import { withStyles } from '@mui/styles';
import styles from "./styles";
import { Store } from "Store";
import Base from "common/constants";
import { GetStateStorage, IsValidNavbarData } from "common/storage";
import { isUserAdmin, isUserAgent } from "common/roles/role";
import { isAKylesAccount } from "common/helpers";
import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Typography,
} from '@mui/material';
import {
  DashboardOutlined as DashboardIcon,
  PeopleOutlined as PeopleIcon,
  ShoppingBasketOutlined as ShoppingBasketIcon,
  LockOpenOutlined as LockOpenIcon,
  TextFields as TextFieldsIcon,
  ImageOutlined as ImageIcon,
  InfoOutlined as InfoIcon,
  AccountBoxOutlined as AccountBoxIcon,
  SettingsOutlined as SettingsIcon,
  Search as SearchIcon,
  Home as HomeIcon,
  Person as PersonIcon,
  Help as HelpIcon,
  LockSharp as LockSharpIcon,
  CreditCard as CreditCardIcon,
  Receipt as ReceiptIcon, 
  History as HistoryIcon,
  PageviewOutlined as PageviewIcon,
  ControlPointDuplicate as ConstantControlIcon,
  Notes as NotesIcon,
  ListAlt as ListAltIcon,
  Streetview as StreetViewIcon,
  Assessment as ReportIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  CenterFocusStrong as CenterFocusStrongIcon,
  AddComment as FeedbackIcon,
  AddToQueue as AdvantagesIcon,
  InsertInvitation as InsertInvitationIcon,
  CalendarToday as CalendarTodayIcon,
  Today as TodayIcon,
  Adjust as AdjustIcon,
  Print as ExportPrintIcon,
  Highlight as HighlightIcon,
  DateRange as DateRangeIcon,
  EventNote as EventNoteIcon,
  DeveloperBoard as DeveloperBoardIcon,
  Event as EventIcon,
} from '@mui/icons-material';
const Sidebar = (props) => {
  const { state, dispatch } = React.useContext(Store);
  const [openReportsList, setOpenReportsList] = useState(false);
  const { userData } = state;
  const { classes, className, sessionSwitchMode } = props;
  const rootClassName = classNames(classes.root, className);
  
  // Use useLocation hook directly
  const location = useLocation();

  // Helper function to check if a path is active
  const isActivePath = (path) => {
    if (!location) return false;
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  /**logo */
  const listgenLogo = (process.env.PUBLIC_URL || '') + "/images/listgen-logo.png";
  const listgenAltLogo = (process.env.PUBLIC_URL || '') + "/images/listgen-text-advanced-v1.png";

  const stateData = GetStateStorage();
  const agentData = (stateData || {}).userData;
  let navbarData =
    agentData && Array.isArray(agentData.navbarInfo)
      ? agentData.navbarInfo[0]
      : {};

  /**Nested Dropdowns */

  // React Router v6: activeClassName is deprecated. Use function form of className
  const navLinkActiveClass = ({ isActive }) =>
    classNames(classes.listItem, { [classes.activeListItem]: isActive });
  let reportNestedList = [
    // {
    //   link: '/sales/report/brokerageperformance',
    //   name: 'Brokerage Performance',
    // },
    // { link: '/sales/report/countyperformance', name: 'County Performance' },
    // { link: '/sales/report/cityperformance', name: 'City Performance' },
    { link: "/sales/report/agentperformance", name: "Agent Performance" },
    // { link: '/sales/report/agentbehaviour', name: 'Agent Behaviour' },
    // { link: '/sales/report/agentdetails', name: 'Agent Details' },
  ];
  /**Count PMA Admin Variables */
  let pADesignationsCount = userData.designationsCount
    ? userData.designationsCount
    : 0;
  let pAAdvantagesCount = userData.advantagesCount
    ? userData.advantagesCount
    : 0;
  let pATestimonialsCount = userData.testimonialsCount
    ? userData.testimonialsCount
    : 0;
  let pAMissionsCount = userData.missionStatementsCount
    ? userData.missionStatementsCount
    : 0;
  let pAAreaCount = userData.navbarInfo ? userData.navbarInfo.length : 1;
  let propertyHighlightsCount = 0;
  //pAAdvantagesCount is area wise so divide by area count also
  pAAdvantagesCount = parseInt(pAAdvantagesCount / pAAreaCount);

  /**
   * Methods
   */

  const handleClickNestedList = (openListVariable, setOpenFn) => {
    setOpenFn(!openListVariable);
  };

  const isNestedListIsOpen = (reportVariable, setOpenFn) => {
    let foundLink = reportVariable.find(
      (item) => item.link === window.location.pathname
    );
    let isOpen = foundLink && Object.keys(foundLink).length > 0 ? true : false;
    setOpenFn(isOpen);
  };

  useEffect(() => {
    isNestedListIsOpen(reportNestedList, setOpenReportsList);
  }, [reportNestedList]); //reportNestedList

  return (
    <nav className={rootClassName}>
      <div className={classes.logoWrapper}>
        <div className={classes.logoInner}>
          <div className={classes.logoFirst}>
            <Link className={classes.logoLink} to="/home">
              <img
                alt="ListGen logo"
                className={classes.logoImage}
                src={listgenLogo}
              />
            </Link>
          </div>
          <div className={classes.logoSecond}>
            <Link className={classes.logoLink} to="/home">
              <img
                alt="ListGen logo"
                className={classes.logoImage}
                src={listgenAltLogo}
              />
            </Link>
          </div>
        </div>
        {/* <Typography
              className={classes.title}
              variant="h4"
            >
              ListGen Dashboard
            </Typography> */}
      </div>
      <Divider className={classes.logoDivider} />
      {/* <div className={classes.profile}>
      </div> */}
      {/* <Divider className={classes.profileDivider} /> */}
      <List component="div" disablePadding>
        <ListItem
          component={NavLink}
          to="/home"
          selected={isActivePath("/home")}
          classes={{ 
            root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/home") }),
            selected: classes.activeListItem,
            gutters: classes.listItemGutter
          }}
        >
          <ListItemIcon className={classes.listItemIcon}>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText
            classes={{ primary: classes.listItemText }}
            primary="Home"
          />
        </ListItem>
      </List>
      <Divider className={classes.profileDivider} />
      {isUserAgent(userData.listgenRoleID) ? (
        <List component="div" disablePadding>
          <ListItem
            component={NavLink}
            to={navbarData ? `/pma/${navbarData.mlsAreaID}` : "/pma"}
            selected={isActivePath("/pma")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/pma") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="View PMA"
            />
          </ListItem>
          <ListItem
            component={NavLink}
            to={navbarData.mlsAreaID ? `/mailpro/${navbarData.mlsAreaID}` : "/mailpro"}
            selected={isActivePath("/mailpro")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/mailpro") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="View MailPro"
            />
          </ListItem>
          <ListItem
            component={NavLink}
            to={"/agent/missionstatements"}
            selected={isActivePath("/agent/missionstatements")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/missionstatements") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <AdjustIcon />
            </ListItemIcon>
            <ListItemText
              classes={{
                root: classes.listItemTextRoot,
                primary: classes.listItemText,
                secondary:
                  pAMissionsCount > 0
                    ? classes.pmaAdminBlueText
                    : classes.pmaAdminErrorText,
              }}
              primary="Mission Statements"
              secondary={
                pAMissionsCount > 0
                  ? "Add more Mission Statements"
                  : "Please add a Mission Statement"
              }
            />
            <ListItemIcon
              className={classNames(classes.listItemIcon, classes.pmaAdminIcon)}
            >
              <Badge
                badgeContent={`${pAMissionsCount}`}
                //color="primary"
                classes={{
                  badge:
                    pAMissionsCount > 0
                      ? classes.pmaAdminBlueBg
                      : classes.pmaAdminErrorBg,
                }}
                className={classes.newBadge}
              />
            </ListItemIcon>
          </ListItem>
          {/* <ListItem
            activeClassName={classes.activeListItem}
            className={classes.listItem}
            component={NavLink}
            to={"/agent/mystrengths"}
            classes={{ gutters: classes.listItemGutter }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <CenterFocusStrongIcon />
            </ListItemIcon>
            <ListItemText
              classes={{
                root: classes.listItemTextRoot,
                primary: classes.listItemText,
                secondary: !pADesignationsCount
                  ? classes.pmaAdminErrorText
                  : pADesignationsCount === Base.PMA_ADMIN.MIN_STRENGTH_COUNT
                  ? classes.pmaAdminBlueText
                  : classes.pmaAdminGreenText,
              }}
              primary="My Strengths / Designations"
              secondary={
                !pADesignationsCount
                  ? "Please add a Strength / Designation"
                  : pADesignationsCount === Base.PMA_ADMIN.MIN_STRENGTH_COUNT
                  ? "You can add more Strengths / Designations"
                  : "All Strengths / Designations added"
              }
            />
            <ListItemIcon
              className={classNames(classes.listItemIcon, classes.pmaAdminIcon)}
            >
              <Badge
                badgeContent={`${pADesignationsCount}`}
                className={classes.newBadge}
                classes={{
                  badge: !pADesignationsCount
                    ? classes.pmaAdminErrorBg
                    : pADesignationsCount === Base.PMA_ADMIN.MIN_STRENGTH_COUNT
                    ? classes.pmaAdminBlueBg
                    : classes.pmaAdminGreenBg,
                }}
              />
            </ListItemIcon>
          </ListItem> */}
          {/*<ListItem
            activeClassName={classes.activeListItem}
            className={classes.listItem}
            component={NavLink}
            to={"/agent/property-highlights"}
            classes={{
              gutters: classes.listItemGutter,
            }}
            className={classes.importantTab}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <HighlightIcon />
            </ListItemIcon>
            <ListItemText
              classes={{
                root: classes.listItemTextRoot,
                primary: classes.listItemText,
              }}
              primary="My Property Highlights"
            />
          </ListItem>*/}

          {/* <ListItem
            activeClassName={classes.activeListItem}
            className={classes.listItem}
            component={NavLink}
            to={"/agent/myadvantages"}
            classes={{ gutters: classes.listItemGutter }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <AdvantagesIcon />
            </ListItemIcon>
            <ListItemText
              classes={{
                root: classes.listItemTextRoot,
                primary: classes.listItemText,
                secondary: !pAAdvantagesCount
                  ? classes.pmaAdminErrorText
                  : pAAdvantagesCount === Base.PMA_ADMIN.MIN_ADVANTAGE_COUNT
                  ? classes.pmaAdminBlueText
                  : classes.pmaAdminGreenText
              }}
              primary="Neighborhood Advantages"
              secondary={
                !pAAdvantagesCount
                  ? "Please add an Advantage"
                  : pAAdvantagesCount === Base.PMA_ADMIN.MIN_ADVANTAGE_COUNT
                  ? "You can add more Advantages"
                  : "All Advantages added"
              }
            />
            <ListItemIcon
              className={classNames(classes.listItemIcon, classes.pmaAdminIcon)}
            >
              <Badge
                badgeContent={`${pAAdvantagesCount}`}
                classes={{
                  badge: !pAAdvantagesCount
                    ? classes.pmaAdminErrorBg
                    : pAAdvantagesCount === Base.PMA_ADMIN.MIN_ADVANTAGE_COUNT
                    ? classes.pmaAdminBlueBg
                    : classes.pmaAdminGreenBg
                }}
                className={classNames(
                  classes.newBadge,
                  classes.pmaAdminGreenText
                )}
              />
            </ListItemIcon>
          </ListItem> */}
          <ListItem
            component={NavLink}
            to={"/agent/clienttestimonials"}
            selected={isActivePath("/agent/clienttestimonials")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/clienttestimonials") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <FeedbackIcon />
            </ListItemIcon>
            <ListItemText
              classes={{
                root: classes.listItemTextRoot,
                primary: classes.listItemText,
                secondary:
                  pATestimonialsCount > 0
                    ? classes.pmaAdminBlueText
                    : classes.pmaAdminErrorText,
              }}
              primary="Client Testimonials"
              secondary={
                pATestimonialsCount > 0
                  ? "You can add more Testimonials"
                  : "Please add a Testimonial"
              }
            />
            <ListItemIcon
              className={classNames(classes.listItemIcon, classes.pmaAdminIcon)}
            >
              <Badge
                badgeContent={`${pATestimonialsCount}`}
                //color="primary"
                classes={{
                  badge:
                    pATestimonialsCount > 0
                      ? classes.pmaAdminBlueBg
                      : classes.pmaAdminErrorBg,
                }}
                className={classes.newBadge}
              />
            </ListItemIcon>
          </ListItem>
          <Divider className={classes.profileDivider} />

          {/*<ListItem
            activeClassName={classes.activeListItem}
            className={classes.listItem}
            component={NavLink}
            to={"/agent/roi/form"}
            classes={{ gutters: classes.listItemGutter }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <FeedbackIcon />
            </ListItemIcon>
            <ListItemText
              classes={{
                root: classes.listItemTextRoot,
                primary: classes.listItemText
              }}
              primary="Agent ROI"
            />
          </ListItem>
          <Divider className={classes.profileDivider} />*/}

          <ListItem
            component={NavLink}
            to="/account"
            selected={isActivePath("/account")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/account") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Update Email or Password"
            />
          </ListItem>
          <ListItem
            component={NavLink}
            to={"/agent/details/ag/" + btoa(userData.listgenUserID)}
            selected={isActivePath("/agent/details")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/details") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Update Profile"
            />
          </ListItem>

          {/* <ListItem
            activeClassName={classes.activeListItem}
            className={classes.listItem}
            component={NavLink}
            // to={'/agent/invoice/history/' + userData.listgenUserID}
            to={`/agent/invoice/history/${btoa(userData.listgenUserID)}/${btoa(
              null
            )}/${btoa(null)}/${btoa(null)}`}
             classes={{gutters: classes.listItemGutter}}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <HistoryIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Invoice History"
            />
          </ListItem> */}

          <ListItem
            component={NavLink}
            to={`/cards/credit/ag/${btoa(userData.listgenUserID)}/${btoa(null)}/${btoa(null)}/${btoa(null)}`}
            selected={isActivePath("/cards/credit")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/cards/credit") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <CreditCardIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Manage Credit Cards"
            />
          </ListItem>

            
          {<ListItem
            component={NavLink}
            to={`/agent/year-end-statement/${userData.listgenUserID}?year=${new Date().getFullYear()}`}
            selected={isActivePath("/agent/year-end-statement")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/year-end-statement") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <ReceiptIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Year End Statement"
            />
          </ListItem>}
          {/* //show only if session switch mode is on for agent  */}
          {/* {sessionSwitchMode ? (
            <ListItem
              activeClassName={classes.activeListItem}
              className={classes.listItem}
              component={NavLink}
              to="/session/switch"
               classes={{gutters: classes.listItemGutter}}
            >
              <ListItemIcon
                className={classes.listItemSpecialSessionSwitchIcon}
              >
                <LockSharpIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemSpecialSessionSwitchText }}
                primary="Session Switch"
                color="primary"
              />
            </ListItem>
          ) : (
              ''
            )} */}
        </List>
      ) : isUserAdmin(userData.listgenRoleID) ? (
        <List component="div" disablePadding>
          {/* <ListItem
            activeClassName={classes.activeListItem}
            className={classes.listItem}
            component={NavLink}
            to="/dashboard"
            classes={{ gutters: classes.listItemGutter }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Dashboard"
            />
          </ListItem> */}
          <ListItem
            component={NavLink}
            to="/agent/mailpro/insights"
            selected={isActivePath("/agent/mailpro/insights")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/mailpro/insights") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <NotesIcon />
            </ListItemIcon>
            <ListItemText
              classes={{
                root: classes.listItemTextRoot,
                primary: classes.listItemText,
              }}
              primary={<Fragment>Mailpro Insights</Fragment>}
            />
          </ListItem>
          <ListItem
            component={NavLink}
            to="/agent/print/manage"
            selected={isActivePath("/agent/print/manage")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/print/manage") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <ExportPrintIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Export & Print Management"
            />
          </ListItem>
          <ListItem
            component={NavLink}
            to="/onboarding/roi/invite/agents"
            selected={isActivePath("/onboarding/roi/invite/agents")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/onboarding/roi/invite/agents") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <CalendarTodayIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Invite Agents for ROI"
            />
          </ListItem>
          <ListItem
            component={NavLink}
            to="/admin/mailing/schedule"
            selected={isActivePath("/admin/mailing/schedule")}
            classes={{ 
              root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/admin/mailing/schedule") }),
              selected: classes.activeListItem,
              gutters: classes.listItemGutter
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <DateRangeIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Mailing Schedule / Calendar"
            />
          </ListItem>

          <Divider className={classes.listDivider} />
          <Fragment>
          <ListItem
              component={NavLink}
              to="/manage/bridge/agents"
              selected={isActivePath("/manage/bridge/agents")}
              classes={{ 
                root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/manage/bridge/agents") }),
                selected: classes.activeListItem,
                gutters: classes.listItemGutter
              }}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <DeveloperBoardIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary={"BayEast/Bridge Members"}
              />
              <ListItemIcon style={{marginRight: '12px'}}>
                <Badge badgeContent={"New"} color="error" className={classes.newBadge} />
              </ListItemIcon>
            </ListItem>
            <ListItem
              component={NavLink}
              to="/agent/pma/schedulesv1"
              selected={isActivePath("/agent/pma/schedulesv1")}
              classes={{ 
                root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/pma/schedulesv1") }),
                selected: classes.activeListItem,
                gutters: classes.listItemGutter
              }}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <EventNoteIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary={"Agent PMA Schedules V1"}
              />
            </ListItem>
            <ListItem
              component={NavLink}
              to="/agent/search"
              selected={isActivePath("/agent/search")}
              classes={{ 
                root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/search") }),
                selected: classes.activeListItem,
                gutters: classes.listItemGutter
              }}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <SearchIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary="Search Agents"
              />
            </ListItem>

            <ListItem
              component={NavLink}
              to="/agent/create"
              selected={isActivePath("/agent/create")}
              classes={{ 
                root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/create") }),
                selected: classes.activeListItem,
                gutters: classes.listItemGutter
              }}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary="Create Agent"
              />
            </ListItem>
            <ListItem
              component={NavLink}
              to="/agent/help/request"
              selected={isActivePath("/agent/help/request")}
              classes={{ 
                root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/agent/help/request") }),
                selected: classes.activeListItem,
                gutters: classes.listItemGutter
              }}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <HelpIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary="Help Requests"
              />
            </ListItem>
            <ListItem
              component={NavLink}
              to="/lg/constants"
              selected={isActivePath("/lg/constants")}
              classes={{ 
                root: classNames(classes.listItem, { [classes.activeListItem]: isActivePath("/lg/constants") }),
                selected: classes.activeListItem,
                gutters: classes.listItemGutter
              }}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <ConstantControlIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary="LG Constants"
              />
            </ListItem>
          </Fragment>


          {/* <ListItem
              className={({isActive}) => classNames(classes.listItem, { [classes.activeListItem]: isActive })}
            classes={{ 
              gutters: classes.listItemGutter
            }}
              component={NavLink}
              to="/admin/hoasubdivion"
               classes={{gutters: classes.listItemGutter}}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <StreetViewIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ root: classes.listItemTextRoot,  primary: classes.listItemText }}
                primary={<Fragment>Hoa/Subdivison</Fragment>}
              />
              <ListItemIcon className={classes.listItemIcon}>
              <Badge badgeContent={"New"} color="error" className={classes.newBadge}/>
              </ListItemIcon>
            </ListItem> */}
          <Fragment>
            {/* <ListItem
                className={({isActive}) => classNames(classes.listItem, { [classes.activeListItem]: isActive })}
            classes={{ 
              gutters: classes.listItemGutter
            }}
                component={NavLink}
                to="/onboarding/invite/agents"
                classes={{ gutters: classes.listItemGutter }}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <CalendarTodayIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Invite Agents for Presentations"
                />
              </ListItem> */}
            {/* <ListItem
                className={({isActive}) => classNames(classes.listItem, { [classes.activeListItem]: isActive })}
            classes={{ 
              gutters: classes.listItemGutter
            }}
                component={NavLink}
                to="/onboarding/presentation/agents"
                classes={{ gutters: classes.listItemGutter }}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <TodayIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Scheduled Presentations"
                />
              </ListItem> */}
            {/* <ListItem
                className={({isActive}) => classNames(classes.listItem, { [classes.activeListItem]: isActive })}
            classes={{ 
              gutters: classes.listItemGutter
            }}
                component={NavLink}
                to="/onboarding/view/brokerages"
                classes={{ gutters: classes.listItemGutter }}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <InsertInvitationIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="View Brokerages"
                />
              </ListItem> */}

          </Fragment>
          {/* <ListItem
            className={({isActive}) => classNames(classes.listItem, { [classes.activeListItem]: isActive })}
            classes={{ 
              gutters: classes.listItemGutter
            }}
            component={NavLink}
            to="/agent/areas-by-city"
             classes={{gutters: classes.listItemGutter}}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText
              classes={{ primary: classes.listItemText }}
              primary="Areas By City"
            />
          </ListItem> */}
          {/* Nested List Code */}
          {/* {isUserAdmin(userData.listgenRoleID) ?
            <Fragment>
          <ListItem
            onClick={event =>
              handleClickNestedList(openReportsList, setOpenReportsList)
            }
            className={classes.listItem}
            className={({isActive}) => classNames(classes.listItem, { [classes.activeListItem]: isActive })}
            classes={{ 
              gutters: classes.listItemGutter
            }}
            component={Link}
             classes={{gutters: classes.listItemGutter}}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <ReportIcon />
            </ListItemIcon>
            <ListItemText
              primary="Reports"
              classes={{ primary: classes.listItemText }}
            />
            {openReportsList ? (
              <ExpandLessIcon color="primary" />
            ) : (
              <ExpandMoreIcon color="primary" />
            )}
          </ListItem>
          <Collapse in={openReportsList} timeout="auto" unmountOnExit>
            {reportNestedList.map((item, key) => {
              return (
                <List
                  component="div"
                  disablePadding
                  key={key}
                  className={classes.nestedList}
                >
                  <ListItem
                    className={({isActive}) => classNames(classes.listItem, { [classes.activeListItem]: isActive })}
                    classes={{ 
                      gutters: classes.listItemGutter
                    }}
                    component={NavLink}
                    to={item.link}
                  >
                    <ListItemIcon className={classes.listItemIcon}>
                      <ReportIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.name}
                      classes={{
                        primary: classNames(
                          classes.listItemText,
                          classes.listItemTextNested
                        )
                      }}
                    />
                  </ListItem>
                </List>
              );
            })}
          </Collapse>
          </Fragment>
          :  ''} */}
        </List>
      ) : ""}
      <Divider className={classes.listDivider} />
    </nav>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Sidebar);
// // // // // // import {
//   Avatar,
//   Divider,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   ListSubheader,
//   Typography,
// } from '@mui/material';
// import {
//   DashboardOutlined as DashboardIcon,
//   PeopleOutlined as PeopleIcon,
//   ShoppingBasketOutlined as ShoppingBasketIcon,
//   LockOpenOutlined as LockOpenIcon,
//   TextFields as TextFieldsIcon,
//   ImageOutlined as ImageIcon,
//   InfoOutlined as InfoIcon,
//   AccountBoxOutlined as AccountBoxIcon,
//   SettingsOutlined as SettingsIcon,
//   Search as SearchIcon,
//   Home as HomeIcon,
//   Person as PersonIcon,
//   Help as HelpIcon,
//   LockSharp as LockSharpIcon,
//   CreditCard as CreditCardIcon,
//   History as HistoryIcon,
//   PageviewOutlined as PageviewIcon,
//   ControlPointDuplicate as ConstantControlIcon,
//   Notes as NotesIcon,
//   ListAlt as ListAltIcon,
//   Streetview as StreetViewIcon,
//   Assessment as ReportIcon,
//   ExpandLess as ExpandLessIcon,
//   ExpandMore as ExpandMoreIcon,
//   CenterFocusStrong as CenterFocusStrongIcon,
//   AddComment as FeedbackIcon,
//   AddToQueue as AdvantagesIcon,
//   InsertInvitation as InsertInvitationIcon,
//   CalendarToday as CalendarTodayIcon,
//   Today as TodayIcon,
//   Adjust as AdjustIcon,
//   RotateLeft as ResetIcon,
//   Highlight as HighlightIcon,
//   DateRange as DateRangeIcon,
//   EventNote as EventNoteIcon,
// } from '@mui/icons-material';
// // // //
// const Sidebar = (props) => {
//   const { state, dispatch } = React.useContext(Store);
//   const [openReportsList, setOpenReportsList] = useState(false);
//   const { userData } = state;
//
//   const { navbarInfo } = userData;
//   const firstAreaID = navbarInfo[0];
//   console.log("firstAreaID", firstAreaID);
//   console.log("userData", userData);
//   const { classes, className, sessionSwitchMode } = props;
//   const rootClassName = classNames(classes.root, className);
//   console.log("******userData1", userData);
//   /**logo */
//   const listgenLogo = "/images/listgen-logo.png";
//   const listgenAltLogo = "/images/listgen-text-advanced-v1.png";
//   /**Nested Dropdowns */
//   let reportNestedList = [
//     // {
//     //   link: '/sales/report/brokerageperformance',
//     //   name: 'Brokerage Performance',
//     // },
//     // { link: '/sales/report/countyperformance', name: 'County Performance' },
//     // { link: '/sales/report/cityperformance', name: 'City Performance' },
//     { link: "/sales/report/agentperformance", name: "Agent Performance" },
//     // { link: '/sales/report/agentbehaviour', name: 'Agent Behaviour' },
//     // { link: '/sales/report/agentdetails', name: 'Agent Details' },
//   ];
//   /**Count PMA Admin Variables */
//   let pADesignationsCount = userData.designationsCount
//     ? userData.designationsCount
//     : 0;
//   let pAAdvantagesCount = userData.advantagesCount
//     ? userData.advantagesCount
//     : 0;
//   let pATestimonialsCount = userData.testimonialsCount
//     ? userData.testimonialsCount
//     : 0;
//   let pAMissionsCount = userData.missionStatementsCount
//     ? userData.missionStatementsCount
//     : 0;
//   let pAAreaCount = userData.navbarInfo ? userData.navbarInfo.length : 1;
//   let propertyHighlightsCount = 0;
//   //pAAdvantagesCount is area wise so divide by area count also
//   pAAdvantagesCount = parseInt(pAAdvantagesCount / pAAreaCount);
//
//   /**
//    * Methods
//    */
//
//   const handleClickNestedList = (openListVariable, setOpenFn) => {
//     setOpenFn(!openListVariable);
//   };
//
//   const isNestedListIsOpen = (reportVariable, setOpenFn) => {
//     let foundLink = reportVariable.find(
//       (item) => item.link === window.location.pathname
//     );
//     let isOpen = foundLink && Object.keys(foundLink).length > 0 ? true : false;
//     setOpenFn(isOpen);
//   };
//
//   useEffect(() => {
//     isNestedListIsOpen(reportNestedList, setOpenReportsList);
//   }, [reportNestedList]); //reportNestedList
//
//   return (
//     <nav className={rootClassName}>
//       <div className={classes.logoWrapper}>
//         <div className={classes.logoInner}>
//           <div className={classes.logoFirst}>
//             <Link className={classes.logoLink} to="/home">
//               <img
//                 alt="ListGen logo"
//                 className={classes.logoImage}
//                 src={listgenLogo}
//               />
//             </Link>
//           </div>
//           <div className={classes.logoSecond}>
//             <Link className={classes.logoLink} to="/home">
//               <img
//                 alt="ListGen logo"
//                 className={classes.logoImage}
//                 src={listgenAltLogo}
//               />
//             </Link>
//           </div>
//         </div>
//         {/* <Typography
//               className={classes.title}
//               variant="h4"
//             >
//               ListGen Dashboard
//             </Typography> */}
//       </div>
//       <Divider className={classes.logoDivider} />
//       {/* <div className={classes.profile}>
//       </div> */}
//       {/* <Divider className={classes.profileDivider} /> */}
//       <List component="div" disablePadding>
//         <ListItem
//           activeClassName={classes.activeListItem}
//           className={classes.listItem}
//           component={NavLink}
//           to="/home"
//           classes={{ gutters: classes.listItemGutter }}
//         >
//           <ListItemIcon className={classes.listItemIcon}>
//             <HomeIcon />
//           </ListItemIcon>
//           <ListItemText
//             classes={{ primary: classes.listItemText }}
//             primary="Home"
//           />
//         </ListItem>
//       </List>
//       <Divider className={classes.profileDivider} />
//       {isUserAgent(userData.listgenRoleID) ? (
//         <List component="div" disablePadding>
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={`/pma/${navbarInfo[0].mlsAreaID}`}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <DashboardIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="View PMA"
//             />
//           </ListItem>
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={`/mailpro/${navbarInfo[0].mlsAreaID}`}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <DashboardIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="View MailPro"
//             />
//           </ListItem>
//           {/* //designationsCount, advantagesCount, testimonialsCount
//           //Base.PMA_ADMIN.MIN_STRENGTH_COUNT
//           //Base.PMA_ADMIN.MAX_STRENGTH_COUNT
//           //Base.PMA_ADMIN.MIN_ADVANTAGE_COUNT
//           //Base.PMA_ADMIN.MAX_ADVANTAGE_COUNT */}
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={"/agent/missionstatements"}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <AdjustIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{
//                 root: classes.listItemTextRoot,
//                 primary: classes.listItemText,
//                 secondary:
//                   pAMissionsCount > 0
//                     ? classes.pmaAdminBlueText
//                     : classes.pmaAdminErrorText,
//               }}
//               primary="Mission Statements"
//               secondary={
//                 pAMissionsCount > 0
//                   ? "Add more Mission Statements"
//                   : "Please add a Mission Statement"
//               }
//             />
//             <ListItemIcon
//               className={classNames(classes.listItemIcon, classes.pmaAdminIcon)}
//             >
//               <Badge
//                 badgeContent={`${pAMissionsCount}`}
//                 //color="primary"
//                 classes={{
//                   badge:
//                     pAMissionsCount > 0
//                       ? classes.pmaAdminBlueBg
//                       : classes.pmaAdminErrorBg,
//                 }}
//                 className={classes.newBadge}
//               />
//             </ListItemIcon>
//           </ListItem>
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={"/agent/mystrengths"}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <CenterFocusStrongIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{
//                 root: classes.listItemTextRoot,
//                 primary: classes.listItemText,
//                 secondary: !pADesignationsCount
//                   ? classes.pmaAdminErrorText
//                   : pADesignationsCount === Base.PMA_ADMIN.MIN_STRENGTH_COUNT
//                   ? classes.pmaAdminBlueText
//                   : classes.pmaAdminGreenText,
//               }}
//               primary="My Strengths / Designations"
//               secondary={
//                 !pADesignationsCount
//                   ? "Please add a Strength / Designation"
//                   : pADesignationsCount === Base.PMA_ADMIN.MIN_STRENGTH_COUNT
//                   ? "You can add more Strengths / Designations"
//                   : "All Strengths / Designations added"
//               }
//             />
//             <ListItemIcon
//               className={classNames(classes.listItemIcon, classes.pmaAdminIcon)}
//             >
//               <Badge
//                 badgeContent={`${pADesignationsCount}`}
//                 className={classes.newBadge}
//                 classes={{
//                   badge: !pADesignationsCount
//                     ? classes.pmaAdminErrorBg
//                     : pADesignationsCount === Base.PMA_ADMIN.MIN_STRENGTH_COUNT
//                     ? classes.pmaAdminBlueBg
//                     : classes.pmaAdminGreenBg,
//                 }}
//               />
//             </ListItemIcon>
//           </ListItem>
//           {/*<ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={"/agent/property-highlights"}
//             classes={{
//               gutters: classes.listItemGutter,
//             }}
//             className={classes.importantTab}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <HighlightIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{
//                 root: classes.listItemTextRoot,
//                 primary: classes.listItemText,
//
//
//               }}
//               primary="My Property Highlights"
//             />
//
//           </ListItem>*/}
//
//           {/* <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={"/agent/myadvantages"}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <AdvantagesIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{
//                 root: classes.listItemTextRoot,
//                 primary: classes.listItemText,
//                 secondary: !pAAdvantagesCount
//                   ? classes.pmaAdminErrorText
//                   : pAAdvantagesCount === Base.PMA_ADMIN.MIN_ADVANTAGE_COUNT
//                   ? classes.pmaAdminBlueText
//                   : classes.pmaAdminGreenText
//               }}
//               primary="Neighborhood Advantages"
//               secondary={
//                 !pAAdvantagesCount
//                   ? "Please add an Advantage"
//                   : pAAdvantagesCount === Base.PMA_ADMIN.MIN_ADVANTAGE_COUNT
//                   ? "You can add more Advantages"
//                   : "All Advantages added"
//               }
//             />
//             <ListItemIcon
//               className={classNames(classes.listItemIcon, classes.pmaAdminIcon)}
//             >
//               <Badge
//                 badgeContent={`${pAAdvantagesCount}`}
//                 classes={{
//                   badge: !pAAdvantagesCount
//                     ? classes.pmaAdminErrorBg
//                     : pAAdvantagesCount === Base.PMA_ADMIN.MIN_ADVANTAGE_COUNT
//                     ? classes.pmaAdminBlueBg
//                     : classes.pmaAdminGreenBg
//                 }}
//                 className={classNames(
//                   classes.newBadge,
//                   classes.pmaAdminGreenText
//                 )}
//               />
//             </ListItemIcon>
//           </ListItem> */}
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={"/agent/clienttestimonials"}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <FeedbackIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{
//                 root: classes.listItemTextRoot,
//                 primary: classes.listItemText,
//                 secondary:
//                   pATestimonialsCount > 0
//                     ? classes.pmaAdminBlueText
//                     : classes.pmaAdminErrorText,
//               }}
//               primary="Client Testimonials"
//               secondary={
//                 pATestimonialsCount > 0
//                   ? "You can add more Testimonials"
//                   : "Please add a Testimonial"
//               }
//             />
//             <ListItemIcon
//               className={classNames(classes.listItemIcon, classes.pmaAdminIcon)}
//             >
//               <Badge
//                 badgeContent={`${pATestimonialsCount}`}
//                 //color="primary"
//                 classes={{
//                   badge:
//                     pATestimonialsCount > 0
//                       ? classes.pmaAdminBlueBg
//                       : classes.pmaAdminErrorBg,
//                 }}
//                 className={classes.newBadge}
//               />
//             </ListItemIcon>
//           </ListItem>
//           <Divider className={classes.profileDivider} />
//
//           {/*<ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={"/agent/roi/form"}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <FeedbackIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{
//                 root: classes.listItemTextRoot,
//                 primary: classes.listItemText
//               }}
//               primary="Agent ROI"
//             />
//           </ListItem>
//           <Divider className={classes.profileDivider} />*/}
//
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to="/account"
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <PersonIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Update Email or Password"
//             />
//           </ListItem>
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={"/agent/details/ag/" + btoa(userData.listgenUserID)}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <AccountBoxIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Update Profile"
//             />
//           </ListItem>
//
//           {/* <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             // to={'/agent/invoice/history/' + userData.listgenUserID}
//             to={`/agent/invoice/history/${btoa(userData.listgenUserID)}/${btoa(
//               null
//             )}/${btoa(null)}/${btoa(null)}`}
//              classes={{gutters: classes.listItemGutter}}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <HistoryIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Invoice History"
//             />
//           </ListItem> */}
//
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to={`/cards/credit/ag/${btoa(userData.listgenUserID)}/${btoa(
//               null
//             )}/${btoa(null)}/${btoa(null)}`}
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <CreditCardIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Manage Credit Cards"
//             />
//           </ListItem>
//           {/* //show only if session switch mode is on for agent  */}
//           {/* {sessionSwitchMode ? (
//             <ListItem
//               activeClassName={classes.activeListItem}
//               className={classes.listItem}
//               component={NavLink}
//               to="/session/switch"
//                classes={{gutters: classes.listItemGutter}}
//             >
//               <ListItemIcon
//                 className={classes.listItemSpecialSessionSwitchIcon}
//               >
//                 <LockSharpIcon />
//               </ListItemIcon>
//               <ListItemText
//                 classes={{ primary: classes.listItemSpecialSessionSwitchText }}
//                 primary="Session Switch"
//                 color="primary"
//               />
//             </ListItem>
//           ) : (
//               ''
//             )} */}
//         </List>
//       ) : (
//         <List component="div" disablePadding>
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to="/dashboard"
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <DashboardIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Dashboard"
//             />
//           </ListItem>
//           {isUserAdmin(userData.listgenRoleID) ? (
//             <Fragment>
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/agent/search"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <SearchIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="Search Agents"
//                 />
//               </ListItem>
//
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/agent/print/manage"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <ResetIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="Print Management"
//                 />
//               </ListItem>
//
//
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/admin/mailing/schedule"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <DateRangeIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="Mailing Schedule / Calendar"
//                 />
//               </ListItem>
//
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/agent/create"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <PeopleIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="Create Agent"
//                 />
//               </ListItem>
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/agent/help/request"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <HelpIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="Help Requests"
//                 />
//               </ListItem>
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/lg/constants"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <ConstantControlIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="LG Constants"
//                 />
//               </ListItem>
//             </Fragment>
//           ) : (
//             ""
//           )}
//           <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to="/agent/mailpro/insights"
//             classes={{ gutters: classes.listItemGutter }}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <NotesIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{
//                 root: classes.listItemTextRoot,
//                 primary: classes.listItemText,
//               }}
//               primary={<Fragment>Mailpro Insights</Fragment>}
//             />
//           </ListItem>
//
//           {/* <ListItem
//               activeClassName={classes.activeListItem}
//               className={classes.listItem}
//               component={NavLink}
//               to="/admin/hoasubdivion"
//                classes={{gutters: classes.listItemGutter}}
//             >
//               <ListItemIcon className={classes.listItemIcon}>
//                 <StreetViewIcon />
//               </ListItemIcon>
//               <ListItemText
//                 classes={{ root: classes.listItemTextRoot,  primary: classes.listItemText }}
//                 primary={<Fragment>Hoa/Subdivison</Fragment>}
//               />
//               <ListItemIcon className={classes.listItemIcon}>
//               <Badge badgeContent={"New"} color="error" className={classes.newBadge}/>
//               </ListItemIcon>
//             </ListItem> */}
//           {isUserAdmin(userData.listgenRoleID) ? (
//             <Fragment>
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/onboarding/invite/agents"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <CalendarTodayIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="Invite Agents for Presentations"
//                 />
//               </ListItem>
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/onboarding/presentation/agents"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <TodayIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="Scheduled Presentations"
//                 />
//               </ListItem>
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/onboarding/view/brokerages"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <InsertInvitationIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="View Brokerages"
//                 />
//               </ListItem>
//               <ListItem
//                 activeClassName={classes.activeListItem}
//                 className={classes.listItem}
//                 component={NavLink}
//                 to="/onboarding/roi/invite/agents"
//                 classes={{ gutters: classes.listItemGutter }}
//               >
//                 <ListItemIcon className={classes.listItemIcon}>
//                   <CalendarTodayIcon />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.listItemText }}
//                   primary="Invite Agents for ROI"
//                 />
//               </ListItem>
//             </Fragment>
//           ) : (
//             ""
//           )}
//           {/* <ListItem
//             activeClassName={classes.activeListItem}
//             className={classes.listItem}
//             component={NavLink}
//             to="/agent/areas-by-city"
//              classes={{gutters: classes.listItemGutter}}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <ListAltIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Areas By City"
//             />
//           </ListItem> */}
//           {/* Nested List Code */}
//           {/* {isUserAdmin(userData.listgenRoleID) ?
//             <Fragment>
//           <ListItem
//             onClick={event =>
//               handleClickNestedList(openReportsList, setOpenReportsList)
//             }
//             className={classes.listItem}
//             activeClassName={classes.activeListItem}
//             component={Link}
//              classes={{gutters: classes.listItemGutter}}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <ReportIcon />
//             </ListItemIcon>
//             <ListItemText
//               primary="Reports"
//               classes={{ primary: classes.listItemText }}
//             />
//             {openReportsList ? (
//               <ExpandLessIcon color="primary" />
//             ) : (
//               <ExpandMoreIcon color="primary" />
//             )}
//           </ListItem>
//           <Collapse in={openReportsList} timeout="auto" unmountOnExit>
//             {reportNestedList.map((item, key) => {
//               return (
//                 <List
//                   component="div"
//                   disablePadding
//                   key={key}
//                   className={classes.nestedList}
//                 >
//                   <ListItem
//                     activeClassName={classes.activeListItem}
//                     className={classes.listItem}
//                     component={NavLink}
//                     to={item.link}
//                      classes={{gutters: classes.listItemGutter}}
//                   >
//                     <ListItemIcon className={classes.listItemIcon}>
//                       <ReportIcon />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={item.name}
//                       classes={{
//                         primary: classNames(
//                           classes.listItemText,
//                           classes.listItemTextNested
//                         )
//                       }}
//                     />
//                   </ListItem>
//                 </List>
//               );
//             })}
//           </Collapse>
//           </Fragment>
//           :  ''} */}
//         </List>
//       )}
//       <Divider className={classes.listDivider} />
//       {/* <List
//           component="div"
//           disablePadding
//           subheader={
//             <ListSubheader className={classes.listSubheader}>
//               Support
//             </ListSubheader>
//           }
//         >
//           <ListItem
//             className={classes.listItem}
//             component="a"
//             href="/contact"
//              classes={{gutters: classes.listItemGutter}}
//           >
//             <ListItemIcon className={classes.listItemIcon}>
//               <InfoIcon />
//             </ListItemIcon>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Customer Support"
//             />
//           </ListItem>
//         </List> */}
//     </nav>
//   );
// };
//
// Sidebar.propTypes = {
//   className: PropTypes.string,
//   classes: PropTypes.object.isRequired,
// };
//
// export default withStyles(styles)(Sidebar);
